import { render, staticRenderFns } from "./RegionMapCard.vue?vue&type=template&id=aea55ff8"
import script from "./RegionMapCard.vue?vue&type=script&lang=js"
export * from "./RegionMapCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports